<template>
  <figure style="width: 100%; height: 100%;display: flex;align-items: center;justify-content: center;">
    <chart :options="lineOptions" @click="changeDateRange" ref="line" auto-resize style='width: 100%; height: 100%' v-if="dataState === 'ready'"></chart>
    <template v-else-if="dataState === 'loading'">
      <center>
        <v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
      </center>
    </template>
    <template v-else-if="dataState === 'noData'">
      <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="primary--text" style="font-size: 40px !important;width:100%">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">no data found</p></div>
    </template>
    <template v-else-if="dataState === 'error'">
      <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="error--text" style="font-size: 40px !important">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">error connecting to server</p></div>
    </template>
  </figure>
</template>

<script>
import axios from 'axios'
import underscore from 'underscore'
import { formatDateTime, formatDate, formatWOM, formatMOY, formatTimeWithSeconds, formatTime, formatDateTimeNoOffset } from '@/helpers/formatters'
import { mapGetters, mapMutations } from 'vuex'
import 'echarts/lib/chart/line'
import { format, subDays } from 'date-fns'

export default {
  props: {
    filters: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      dataState: 'loading',
      timeInterval: 'day',
      months: [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ],
      hourly: false,
      lineOptions: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          data: ['Total Tweets', 'Regular Tweets', 'Retweets', 'Quote Tweets', 'Reply Tweets']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            data: []
          }
        ],
        yAxis: [
          {
            type: 'value',
            minInterval: 1
          }
        ],
        series: [{
          name: 'Articles',
          type: 'line',
          data: []
        }]
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters('filters', ['getQuery'])
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    ...mapMutations('filters', ['setCustomFilters']),
    changeDateRange: function (value) {
      if (!this.hourly) {
        if (this.timeInterval === 'hour') {
          this.hourly = true
          var filterDateYear = new Date(this.filters.toDate).getFullYear()
          var month = this.months.indexOf(value.name.substring(0, value.name.indexOf(' ')))
          var day = value.name.substring(value.name.indexOf(' ') + 1, value.name.indexOf(','))
          var hour = Number(value.name.substring(value.name.indexOf(', ') + 1, value.name.indexOf(':')))
          if (value.name.indexOf('PM') !== -1 && hour !== 12) {
            hour = hour + 12
          }
          var hourlyDay = new Date(filterDateYear, month, day, hour, 0, 0)
          var endTime = new Date(hourlyDay)
          endTime.setMinutes(59)
          endTime.setSeconds(59)
          this.setCustomFilters({fromDate: format(subDays(hourlyDay, 0), 'YYYY-MM-DD'), toDate: format(subDays(hourlyDay, 0), 'YYYY-MM-DD'), fromTime: formatTimeWithSeconds(hourlyDay), toTime: formatTimeWithSeconds(endTime)})
        } else if (this.timeInterval === 'month') {
          var monthIndex = this.months.indexOf(value.name.substring(0, 3))
          var year = value.name.substring(4, 9)
          var newFromDate = new Date(year, monthIndex, 1)
          var newEndDate = new Date(year, monthIndex + 1, 1)
          this.setCustomFilters({fromDate: format(subDays(newFromDate, 0), 'YYYY-MM-DD'), toDate: format(subDays(newEndDate, 0), 'YYYY-MM-DD')})
        } else if (this.timeInterval === 'wom') {
          var weekWeekly = Number(value.name.substr(5, 1))
          var monthWeekly = this.months.indexOf(value.name.substr(8, 3))
          var yearWeekly = value.name.substring(12, 17)
          var weeklyFromDate = new Date(yearWeekly, monthWeekly, (weekWeekly * 7) - 6)
          var weeklyEndDate = new Date(yearWeekly, monthWeekly, (weekWeekly * 7) - 1)
          this.setCustomFilters({fromDate: format(subDays(weeklyFromDate, 0), 'YYYY-MM-DD'), toDate: format(subDays(weeklyEndDate, 0), 'YYYY-MM-DD')})
        } else {
          this.setCustomFilters({fromDate: format(subDays(value.name, 0), 'YYYY-MM-DD'), toDate: format(subDays(value.name, 0), 'YYYY-MM-DD')})
          this.hourly = false
        }
      } else {
        this.setCustomFilters({fromTime: [], toTime: []})
        this.hourly = false
      }
    },
    getMonth: function (month) {
      return this.months[month]
    },
    getData: function () {
      var toDay = 24 * 60 * 60 * 1000
      var timeInterval = (new Date(this.filters.toDate) - new Date(this.filters.fromDate)) / toDay
      if (Array.isArray(this.filters.toTime) || Array.isArray(this.filters.fromTime)) {
        this.hourly = false
      } else {
        this.hourly = true
      }
      if (this.hourly) {
        this.timeInterval = 'minute'
      } else if (timeInterval <= 7) {
        this.timeInterval = 'hour'
      } else if (timeInterval <= 91) {
        this.timeInterval = 'day'
      } else if (timeInterval <= 183) {
        this.timeInterval = 'wom'
      } else {
        this.timeInterval = 'month'
      }
      this.dataState = 'loading'
      axios.all([
        this.$store.dispatch('getTweetsTypesVolume', this.getQuery({interval: this.timeInterval}))
      ]).then(axios.spread((r1) => {
        if (r1.data.status === 'SUCCESS') {
          let data = []
          let seriesDataForTotalTweets = []
          let seriesDataForRegularTweets = []
          let seriesDataForRetweets = []
          let seriesDataForQuoteTweets = []
          let seriesDataForReplyTweets = []
          let i = 0
          let date = new Date()

          if (r1.data.payload.length === 0) {
            data = [{value: 0, name: 'None'}]
            seriesDataForTotalTweets = [{value: 0, name: 'None'}]
            seriesDataForRegularTweets = [{value: 0, name: 'None'}]
            seriesDataForRetweets = [{value: 0, name: 'None'}]
            seriesDataForQuoteTweets = [{value: 0, name: 'None'}]
            seriesDataForReplyTweets = [{value: 0, name: 'None'}]
            this.dataState = 'noData'
          } else {
            if (r1.data.payload[0].hasOwnProperty('_created_at_minute')) {
              var startTime = new Date(this.filters.fromDate + ' ' + this.filters.fromTime)
              var endTime = new Date(this.filters.toDate + ' ' + this.filters.toTime)
              while (startTime <= endTime) {
                data.push(formatTime(startTime))
                startTime = new Date(startTime.setMinutes(startTime.getMinutes() + 1))
                seriesDataForTotalTweets.push(0)
                seriesDataForRegularTweets.push(0)
                seriesDataForRetweets.push(0)
                seriesDataForQuoteTweets.push(0)
                seriesDataForReplyTweets.push(0)
              }
              for (i = 0; i < r1.data.payload.length; i++) {
                var itemTime = formatTime(new Date(Date.UTC(r1.data.payload[i]._created_at_year, r1.data.payload[i]._created_at_month - 1, r1.data.payload[i]._created_at_day, r1.data.payload[i]._created_at_hour, r1.data.payload[i]._created_at_minute)))
                seriesDataForTotalTweets[data.indexOf(itemTime)] = r1.data.payload[i]._total_tweet_count
                seriesDataForRegularTweets[data.indexOf(itemTime)] = r1.data.payload[i]._regular_tweet_count
                seriesDataForRetweets[data.indexOf(itemTime)] = r1.data.payload[i]._retweet_count
                seriesDataForQuoteTweets[data.indexOf(itemTime)] = r1.data.payload[i]._quote_count
                seriesDataForReplyTweets[data.indexOf(itemTime)] = r1.data.payload[i]._reply_count
              }
            } else if (r1.data.payload[0].hasOwnProperty('_created_at_hour')) {
              var hour = new Date(this.filters.fromDate)
              var hourEnd = new Date(this.filters.toDate)

              hour.setHours(0)
              hour.setMinutes(0)
              hour.setSeconds(0)
              hourEnd.setHours(24)
              hourEnd.setMinutes(0)
              hourEnd.setSeconds(0)

              while (hour <= hourEnd) {
                data.push(formatDateTimeNoOffset(hour))
                hour = new Date(hour.setHours(hour.getHours() + 1))
                seriesDataForTotalTweets.push(0)
                seriesDataForRegularTweets.push(0)
                seriesDataForRetweets.push(0)
                seriesDataForQuoteTweets.push(0)
                seriesDataForReplyTweets.push(0)
              }
              for (i = 0; i < r1.data.payload.length; i++) {
                date = formatDateTime(new Date(r1.data.payload[i]._created_at_year, r1.data.payload[i]._created_at_month - 1, r1.data.payload[i]._created_at_day, r1.data.payload[i]._created_at_hour))
                seriesDataForTotalTweets[data.indexOf(date)] = r1.data.payload[i]._total_tweet_count
                seriesDataForRegularTweets[data.indexOf(date)] = r1.data.payload[i]._regular_tweet_count
                seriesDataForRetweets[data.indexOf(date)] = r1.data.payload[i]._retweet_count
                seriesDataForQuoteTweets[data.indexOf(date)] = r1.data.payload[i]._quote_count
                seriesDataForReplyTweets[data.indexOf(date)] = r1.data.payload[i]._reply_count
              }
            } else if (r1.data.payload[0].hasOwnProperty('_created_at_day')) {
              var day = new Date(this.filters.fromDate)
              var dayEnd = new Date(this.filters.toDate)

              day.setHours(0)
              day.setMinutes(0)
              day.setSeconds(0)
              dayEnd.setHours(23)
              dayEnd.setMinutes(59)
              dayEnd.setSeconds(59)

              while (day <= dayEnd) {
                data.push(formatDate(day))
                day = new Date(day.setDate(day.getDate() + 1))
                seriesDataForTotalTweets.push(0)
                seriesDataForRegularTweets.push(0)
                seriesDataForRetweets.push(0)
                seriesDataForQuoteTweets.push(0)
                seriesDataForReplyTweets.push(0)
              }

              for (i = 0; i < r1.data.payload.length; i++) {
                date = formatDate(new Date(r1.data.payload[i]._created_at_year, r1.data.payload[i]._created_at_month - 1, r1.data.payload[i]._created_at_day))
                seriesDataForTotalTweets[data.indexOf(date)] = r1.data.payload[i]._total_tweet_count
                seriesDataForRegularTweets[data.indexOf(date)] = r1.data.payload[i]._regular_tweet_count
                seriesDataForRetweets[data.indexOf(date)] = r1.data.payload[i]._retweet_count
                seriesDataForQuoteTweets[data.indexOf(date)] = r1.data.payload[i]._quote_count
                seriesDataForReplyTweets[data.indexOf(date)] = r1.data.payload[i]._reply_count
              }
            } else if (r1.data.payload[0].hasOwnProperty('_created_at_wom')) {
              var startDate = new Date(this.filters.fromDate)
              var endDate = new Date(this.filters.toDate)
              var year = startDate.getFullYear()
              var month = startDate.getMonth()
              var dayWeekly = 0
              var dayOfMonth = startDate.getDate()
              data.push('Week ' + (Math.ceil(startDate.getDate() / 7)) + ', ' + this.getMonth(month) + ' ' + year)
              seriesDataForTotalTweets.push(0)
              seriesDataForRegularTweets.push(0)
              seriesDataForRetweets.push(0)
              seriesDataForQuoteTweets.push(0)
              seriesDataForReplyTweets.push(0)
              var weekNo = Math.ceil(startDate.getDate() / 7)
              while (startDate <= endDate) {
                startDate = new Date(year, month, dayOfMonth + 1)
                month = startDate.getMonth()
                if (month === 0) {
                  year = startDate.getFullYear()
                }
                dayWeekly = startDate.getDay()
                dayOfMonth = startDate.getDate()
                if (dayWeekly === 0 || dayOfMonth === 1) {
                  weekNo = dayOfMonth === 1 ? 1 : weekNo + 1
                  var weekData = 'Week ' + weekNo + ', ' + this.getMonth(month) + ' ' + year
                  data.push(weekData)
                  seriesDataForTotalTweets.push(0)
                  seriesDataForRegularTweets.push(0)
                  seriesDataForRetweets.push(0)
                  seriesDataForQuoteTweets.push(0)
                  seriesDataForReplyTweets.push(0)
                }
              }
              for (i = 0; i < r1.data.payload.length; i++) {
                var week = formatWOM({week: r1.data.payload[i]._created_at_wom, month: r1.data.payload[i]._created_at_month, year: r1.data.payload[i]._created_at_year})
                seriesDataForTotalTweets[data.indexOf(week)] = r1.data.payload[i]._total_tweet_count
                seriesDataForRegularTweets[data.indexOf(week)] = r1.data.payload[i]._regular_tweet_count
                seriesDataForRetweets[data.indexOf(week)] = r1.data.payload[i]._retweet_count
                seriesDataForQuoteTweets[data.indexOf(week)] = r1.data.payload[i]._quote_count
                seriesDataForReplyTweets[data.indexOf(week)] = r1.data.payload[i]._reply_count
              }
            } else {
              var monthStart = new Date(this.filters.fromDate)
              var monthEnd = new Date(this.filters.toDate)
              var refDay = monthEnd.getDate()
              var yearMonthly = monthStart.getFullYear()

              while (monthStart <= monthEnd) {
                var monthOfYear = monthStart.getMonth()
                if (monthOfYear === 0) {
                  yearMonthly = monthStart.getFullYear()
                }
                data.push(formatMOY({month: monthOfYear, year: yearMonthly}))
                seriesDataForTotalTweets.push(0)
                seriesDataForRegularTweets.push(0)
                seriesDataForRetweets.push(0)
                seriesDataForQuoteTweets.push(0)
                seriesDataForReplyTweets.push(0)
                monthStart = new Date(yearMonthly, monthOfYear + 1, refDay)
              }

              for (i = 0; i < r1.data.payload.length; i++) {
                var monthFormatted = formatMOY({month: r1.data.payload[i]._created_at_month - 1, year: r1.data.payload[i]._created_at_year})
                seriesDataForTotalTweets[data.indexOf(monthFormatted)] = r1.data.payload[i]._total_tweet_count
                seriesDataForRegularTweets[data.indexOf(monthFormatted)] = r1.data.payload[i]._regular_tweet_count
                seriesDataForRetweets[data.indexOf(monthFormatted)] = r1.data.payload[i]._retweet_count
                seriesDataForQuoteTweets[data.indexOf(monthFormatted)] = r1.data.payload[i]._quote_count
                seriesDataForReplyTweets[data.indexOf(monthFormatted)] = r1.data.payload[i]._reply_count
              }
            }
            this.lineOptions.xAxis = []
            this.lineOptions.xAxis.push({data: data})
            this.lineOptions.series = []
            this.lineOptions.series.push({
              name: 'Total Tweets',
              type: 'line',
              areaStyle: {normal: {}},
              data: seriesDataForTotalTweets
            })
            this.lineOptions.series.push({
              name: 'Regular Tweets',
              stack: 'Total Tweets',
              type: 'line',
              areaStyle: {normal: {}},
              data: seriesDataForRegularTweets
            })
            this.lineOptions.series.push({
              name: 'Retweets',
              stack: 'Total Tweets',
              type: 'line',
              areaStyle: {normal: {}},
              data: seriesDataForRetweets
            })
            this.lineOptions.series.push({
              name: 'Quote Tweets',
              stack: 'Total Tweets',
              type: 'line',
              areaStyle: {normal: {}},
              data: seriesDataForQuoteTweets
            })
            this.lineOptions.series.push({
              name: 'Reply Tweets',
              stack: 'Total Tweets',
              type: 'line',
              areaStyle: {normal: {}},
              data: seriesDataForReplyTweets
            })
            this.dataState = 'ready'
          }
        } else {
          this.dataState = 'error'
          this.notify({message: 'Something went wrong while fetching data.', show: true})
        }
      })).catch((err) => {
        this.dataState = 'error'
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    }
  },
  watch: {
    filters: {
      deep: true,
      immediate: true,
      handler (newVal, oldVal) {
        if (!underscore.isEqual(newVal, oldVal) && this.filters.dirty === false) {
          this.getData()
        }
      }
    },
    loading: {
      immediate: true,
      handler (newVal, oldVal) {
        if (newVal === true) {
          let line = this.$refs.line
          if (line) {
            line.showLoading({
              text: '',
              color: '#4ea397',
              maskColor: 'rgba(255, 255, 255, 0.4)'
            })
          }
        } else {
          let line = this.$refs.line
          if (line) {
            line.hideLoading()
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/TweetsTypesVolumeLineChart.vue